export const iconStyle = 'h-5 w-5 text-white';
